import { name } from './name-column';
import { teamRole } from './team-role-column';

export const columns = [name, teamRole];
